import styled from 'styled-components';

type HeadingProps = {
  active?: boolean;
};

export const H1 = styled.h1<HeadingProps>`
  font-family: 'Ubuntu', sans-serif;
  font-size: ${({ theme }) => theme.TYPOGRAPHY.h1.fontSize};
  font-weight: ${({ theme }) => theme.TYPOGRAPHY.h1.fontWeight};
  color: ${({ theme, active = true }) =>
    active ? theme.UI_COLORS.secondary : theme.UI_COLORS.medium_gray};
  transition: color 0.3s ease-out;

  &:hover {
    color: ${({ theme }) => theme.UI_COLORS.secondary};
  }
`;

export const H2 = styled.h2`
  font-family: 'Ubuntu', sans-serif;
  font-size: ${({ theme }) => theme.TYPOGRAPHY.h2.fontSize};
  font-weight: ${({ theme }) => theme.TYPOGRAPHY.h2.fontWeight};
  color: ${({ theme }) => theme.UI_COLORS.secondary};
  text-decoration: none;
`;
